var lastScrollTop = 0;
//resize sizes
let w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;


(function(){

	document.addEventListener("DOMContentLoaded", function(event) {
		window.onload = onLoad();
	});

	// Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
	let defaultSettings = {loop: true,speed: 700,effect: 'fade',fadeEffect: {crossFade: true},autoplay: {delay: 5000,disableOnInteraction: false}};

	// start slider default
    let allSwipper =[];
	document.querySelectorAll('.js-swiper').forEach((element,i) => {

		let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaultSettings;

		let combinedOps = Object.assign({}, defaultSettings, swiperConfig);


		element.setAttribute(`data-swiper-${i}`,"");

		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);

        allSwipper[i] = swiper;

	});



	//// Forms animation for labels
	//email signup animation
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_FNAME')) {
		document.getElementById('email-signup_FNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_LNAME')) {
		document.getElementById('email-signup_LNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	//CMS forms label animation
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

	
	document.querySelector('.js-cta').addEventListener('click', function(e){
		e.preventDefault();
		if(document.getElementById('meetingsrfpform-form')){
			animateTo('meetingsrfpform-form');
		} else {
			window.open(site_url + '#meetingsrfpform-form','_self')
		}
		
	})

	//vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				if(document.getElementById(currentTarget)){
					document.getElementById(currentTarget).classList.add('open')
				}
				
				
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				/*let currentTarget = this.parentElement.parentElement.id;*/

				let currentTarget = allLightcloses[j].parentElement;
				if( !currentTarget.classList.contains('open') ){
					currentTarget = currentTarget.parentElement;
					if( !currentTarget.classList.contains('open') ){
						currentTarget = currentTarget.parentElement;
					}
				}

				if(currentTarget)
					currentTarget.classList.remove('open')
			});
		}
	}

	if(document.getElementsByClassName('js-accordion-title').length > 0){
		document.querySelectorAll('.js-accordion-title').forEach(item => {
			item.addEventListener('click', function(){
				let currentParent = item.parentElement;
				let currentCopyHeight = currentParent.getElementsByClassName('wrap')[0].clientHeight;
				let currentCopy = currentParent.getElementsByClassName('js-accordion-copy')[0];
	
				console.log(item,currentParent);
	
				if(currentParent.classList.contains('open')){
					currentParent.classList.remove('open');
					currentCopy.style.height = '0';
				} else {
					currentParent.classList.add('open');
					currentCopy.style.height = currentCopyHeight + 'px';
				}
	
			})
		});
	}

	if(document.getElementsByClassName('js-cat').length > 0){
		document.querySelectorAll('.js-cat').forEach(item => {
			item.addEventListener('click', function(){
				item.parentElement.classList.toggle('active')
			})
		})
	}


}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		// downscroll code
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
		
		}
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}



function onLoad(){
 w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

	convertBtn();

	//Check anchor on URL
	let anchorHref = window.location.href;
	if(anchorHref.indexOf('#') > 0){
		if(anchorHref.split('#').length === 2){
			let windowTarget = anchorHref.split('#')[1];
			if(document.getElementById(windowTarget)){
				setTimeout(() => {
					animateTo(windowTarget);
				}, 600);
			}
		}
	}

	if(document.getElementsByClassName('top-content').length > 0 ){
		scrollW();
	} else {
		document.getElementById('header').classList.add('scroll');
	}
	window.addEventListener('scroll', function(){
		if(document.getElementsByClassName('top-content').length > 0 ){
			scrollW();
		} else {
			document.getElementById('header').classList.add('scroll');
		}
	})

	if(document.querySelector('.js-tablet-burger')){
		document.querySelector('.js-tablet-burger').addEventListener('click', function(){
			document.getElementById('primary-nav').classList.add('open')
		});
		document.getElementById('primary-nav').addEventListener('click', function(e){
			console.log(e.target.classList.contains('privary-navigation__item'))
			document.getElementById('primary-nav').classList.remove('open')
		});
	}
	if(document.getElementById('menuBurger')){
		document.getElementById('menuBurger').addEventListener('click', function(){
			document.getElementById('mainNavContainer').classList.add('open')
		});
		document.querySelector('.js-main-close').addEventListener('click', function(e){
			
			document.getElementById('mainNavContainer').classList.remove('open')
		});
	}
	
}


function convertBtn() {
	if (document.getElementsByClassName('btn').length > 0) {
		let ALL_BTNS = document.querySelectorAll('.btn');
		ALL_BTNS.forEach((btn) => {
			if (btn.getAttribute('type') !== 'submit') {
				let INNER_TEXT = btn.innerHTML;
				btn.innerHTML = '<span>' + INNER_TEXT + '</span>';
			}
		});
	}
}


//vanilla js scroll TO animation
function animateTo(target) {
	var gotoTarget = offset(document.getElementById(target)).top - 50;
	var from = window.pageYOffset;
	var to = gotoTarget;
	var duration = 1300;
	var start = new Date().getTime();

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start;

		if (from <= to) {
			var y = easeInOutQuart(time, from, to - from, duration);
		} else {
			var y = easeInOutQuart(time, from, -(from - to), duration);
		}
		window.scrollTo(0, y);
		if (time >= duration) clearInterval(timer);
	}, 1000 / 60);

	window.scrollTo(0, from);
}
//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
	return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}
// GALLERY-FLEX FULLSCRREN MODE
if (typeof customLightbox !== 'undefined') {
	customLightbox.fullScreen = true;
	//customLightbox.wideArrows = true;
}